import { getNamespacedBy } from '@/store/utils'

export const actionTypes = {
  FETCH_SOCIAL_ENTITIES: 'fetchSocialEntities'
}

export const globalActions = getNamespacedBy('socialEntity', actionTypes)
